export const COMPANY_NAME = '上海复溯科技有限公司'
export const COMPANY_SHORT_NAME = '复溯数能云'



// WEBPACK FOOTER //
// ./src/constants/index.js